import React, { Component } from 'react';
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";

import Navbar from '../../EndUser/EU-Navbar.jsx';
import EUMediaCard from '../../EndUser/EUMediaCard';
import { LoadingIcon } from '../../Common/Loading_Icon';
import EmptyState from '../../Common/EmptyState';

import ModalRoutes from '../ModalRoutes'

import { setList } from '../../../Actions/endUserActions';
import { Trans } from 'react-i18next';

class EUMedia extends Component {
    constructor(props) {
        super(props);

        this.changeTab = this.changeTab.bind(this);
        this.renderTab = this.renderTab.bind(this);

        this.state = {
            current_tab: "Outstanding",
            loaded_outstanding: false,
            outstanding_bookings: [],
            loaded_completed: false,
            completed_media: [],
            loaded_dismissed: false,
            dismissed_bookings: []
        };
    }

    componentDidMount() {

        document.title = "Media - FleetXPress";
        
        var self = this;
        if (this.state.current_tab === "Outstanding") {
            if (this.props.endUser.loaded) {
                this.setState({
                    loaded_outstanding: true
                })
            } else {
                axios.get('/ajax/eu-media/outstanding')
                .then(function(response) {
                    self.props.dispatch(setList("SET_OUTSTANDING_BOOKINGS_LIST", response?.data))
                    self.setState({
                        loaded_outstanding: true
                    })
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            }
        } else if (this.state.current_tab === "Completed") {
            axios.get('/ajax/eu-media/completed')
            .then(function(response) {
                self.props.dispatch(setList("SET_COMPLETED_MEDIA_LIST", response?.data))
                self.setState({
                    loaded_completed: true
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else if (this.state.current_tab === "Dismissed") {
            axios.get('/ajax/eu-media/dismissed')
            .then(function(response) {
                self.props.dispatch(setList("SET_DISMISSED_BOOKINGS_LIST", response?.data))
                self.setState({
                    loaded_dismissed: true
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    changeTab(tab) {
        var self = this;
        if (tab === "Outstanding") {
            this.setState({
                current_tab: "Outstanding"
            })

            axios.get('/ajax/eu-media/outstanding')
            .then(function(response) {
                self.props.dispatch(setList("SET_OUTSTANDING_BOOKINGS_LIST", response?.data))
                self.setState({
                    loaded_outstanding: true
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else if (tab === "Completed") {
            this.setState({
                current_tab: "Completed"
            })
            
            axios.get('/ajax/eu-media/completed')
            .then(function(response) {
                self.props.dispatch(setList("SET_COMPLETED_MEDIA_LIST", response?.data))
                self.setState({
                    loaded_completed: true
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else if (tab === "Dismissed") {
            this.setState({
                current_tab: "Dismissed"
            })

            axios.get('/ajax/eu-media/dismissed')
            .then(function(response) {
                self.props.dispatch(setList("SET_DISMISSED_BOOKINGS_LIST", response?.data))
                self.setState({
                    loaded_dismissed: true
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    renderTab() {
        if (this.state.current_tab === "Outstanding" && this.state.loaded_outstanding) {
            return(
                <div className = "tabs-content bkg-white-dark no-border">
                    <div className = "tabs-panel is-active" id = "current">
                        {
                            this.props.endUser.outstanding_bookings && this.props.endUser.outstanding_bookings.length > 0 ?
                                this.props.endUser.outstanding_bookings.map((booking) => {
                                    return(
                                        <EUMediaCard type="OUTSTANDING" booking={booking} img = {'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + booking.vehicle.Photos} year = {booking.vehicle.Year} make = {booking.vehicle.Make} model = { booking.vehicle.Model} trim = {booking.vehicle.Trim} pickupdate = {moment(booking.Start_Date).format("MMM DD, YYYY")} dropoffdate = {moment(booking.End_Date).format("MMM DD, YYYY")}  history={this.props.history} match={this.props.match} location={this.props.location}/>
                                    )
                                })
                            :
                                <div className = "w-100">
                                    <EmptyState image = "Media_Inactive.svg" text = "No Outstanding Media"/>
                                </div>
                        }
                        <div className = "clearfix"></div>
                    </div>
                </div>
            )
        } else if (this.state.current_tab === "Completed" && this.state.loaded_completed) {
            return(
                <div className = "tabs-content bkg-white-dark no-border">
                    <div className = "tabs-panel is-active" id = "current">
                    {
                            this.props.endUser.completed_media && this.props.endUser.completed_media.length > 0 ?
                                this.props.endUser.completed_media.map((media) => {
                                    return(
                                        <EUMediaCard type="COMPLETED" media={media} img = {'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + media.booking.vehicle.Photos} year = {media.booking.vehicle.Year} make = {media.booking.vehicle.Make} model = {media.booking.vehicle.Model} trim = {media.booking.vehicle.Trim} pickupdate = {moment(media.booking.Start_Date).format("MMM DD, YYYY")} dropoffdate = {moment(media.booking.End_Date).format("MMM DD, YYYY")}  history={this.props.history} match={this.props.match} location={this.props.location}/>
                                    )
                                })
                            :
                                <div className = "w-100">
                                    <EmptyState image = "Media_Inactive.svg" text = "No Completed Media"/>
                                </div>
                        }
                        <div className = "clearfix"></div>
                    </div>
                </div>
            )
        } else if (this.state.current_tab === "Dismissed" && this.state.loaded_dismissed) {
            return(
                <div className = "tabs-content bkg-white-dark no-border">
                    <div className = "tabs-panel is-active" id = "current">
                        {
                            this.props.endUser.dismissed_bookings && this.props.endUser.dismissed_bookings.length > 0 ?
                                this.props.endUser.dismissed_bookings.map((booking) => {
                                    return(
                                        <EUMediaCard type="DISMISSED" booking={booking} img = {'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + booking.vehicle.Photos} year = {booking.vehicle.Year} make = {booking.vehicle.Make} model = { booking.vehicle.Model} trim = {booking.vehicle.Trim} pickupdate = {moment(booking.Start_Date).format("MMM DD, YYYY")} dropoffdate = {moment(booking.End_Date).format("MMM DD, YYYY")}  history={this.props.history} match={this.props.match} location={this.props.location}/>
                                    )
                                })
                            :
                                <div className = "w-100">
                                    <EmptyState image = "Media_Inactive.svg" text = "No Dismissed Media"/>
                                </div>
                        }
                        <div className = "clearfix"></div>
                    </div>
                </div>
            )
        } else {
            return(
                <div className = "tabs-content bkg-white-dark no-border">
                    <div className = "tabs-panel is-active" id = "current">
                        <LoadingIcon />
                        <div className = "clearfix"></div>
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                <div className = "eu-bookings eu-container">
                    <div className = "eu-bookings-top bkg-primary-light">
                        <div className = "eu-bookings-wrapper pl-24 pr-24">
                            <h1 className = "white pt-16 pb-16">Media</h1>
                            <ul className = "tabs white bkg-primary-light no-border no-padding" data-deep-link="true" data-deep-link-smudge="500" data-tabs id = "booking-tabs">
                                <li className={"tabs-title" + (this.state.current_tab === "Outstanding" ? " is-active" : "")} onClick={() => this.changeTab("Outstanding")}>
                                    <a aria-selected = {this.state.current_tab === "Outstanding" ? "true" : "false"}>
                                        <Trans>Outstanding</Trans>
                                    </a>
                                </li>
                                <li className={"tabs-title" + (this.state.current_tab === "Completed" ? " is-active" : "")} onClick={() => this.changeTab("Completed")}>
                                    <a aria-selected = {this.state.current_tab === "Completed" ? "true" : "false"}>
                                        <Trans>Completed</Trans>
                                    </a>
                                </li>
                                <li className={"tabs-title" + (this.state.current_tab === "Dismissed" ? " is-active" : "")} onClick={() => this.changeTab("Dismissed")}>
                                    <a aria-selected = {this.state.current_tab === "Dismissed" ? "true" : "false"}>
                                        <Trans>Dismissed</Trans>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {this.renderTab()}
                </div>
                <ModalRoutes match={this.props.match} history={this.props.history}/>
            </div>  
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser
})

export default connect(mapStateToProps)(EUMedia)